var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VpCheckbox',_vm._b({ref:"checkbox",staticClass:"vcl-table-checkbox",on:{"input":_vm.itemSelected}},'VpCheckbox',{ value: _vm.isSelected, styles: Object.assign({}, {size: 12, borderRadius: '2px'}, _vm.styles), icon: _vm.icon },false))}
var staticRenderFns = []

export { render, staticRenderFns }